// extracted by mini-css-extract-plugin
export default {"backLink":"backLink__GLhuPSacdkem","sendLink":"sendLink__mo_0WqnW5rBt"};